import { render } from "./cargarDocumentosLicitaciones.vue?vue&type=template&id=6831dafc&scoped=true"
import script from "./cargarDocumentosLicitaciones.vue?vue&type=script&lang=js"
export * from "./cargarDocumentosLicitaciones.vue?vue&type=script&lang=js"

import "./cargarDocumentosLicitaciones.vue?vue&type=style&index=0&id=6831dafc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6831dafc"]])

export default __exports__